import _implicitStylesheets from "./agenticDetails.css";
import _implicitScopedStylesheets from "./agenticDetails.scoped.css?scoped=true";
import _wdsPopoverTooltip from "wds/popoverTooltip";
import _wdsTitledGroup from "wds/titledGroup";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<img src="/images/agent_astro_blue.svg" class="agentforce-icon${0}" size="medium"${2}>`;
const $fragment2 = parseFragment`<span class="agentforce-label${0}"${2}>${"t1"}</span>`;
const stc0 = {
  classMap: {
    "agentforce-header": true
  },
  key: 0
};
const stc1 = {
  "tooltip-container": true
};
const stc2 = {
  "titled-group-wrapper": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {st: api_static_fragment, d: api_dynamic_text, sp: api_static_part, c: api_custom_element, h: api_element} = $api;
  return [api_element("div", stc0, [api_static_fragment($fragment1, 2), api_static_fragment($fragment2, 4, [api_static_part(1, null, api_dynamic_text($cmp.label))]), $cmp.hasInfoIcon ? api_custom_element("wds-popover-tooltip", _wdsPopoverTooltip, {
    classMap: stc1,
    props: {
      "tooltipData": $cmp.tooltipData
    },
    key: 5
  }) : null]), $cmp.agentforceBadges.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    classMap: stc2,
    props: {
      "badges": $cmp.agentforceBadges
    },
    key: 6
  }) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4a6qqtormi2";
tmpl.legacyStylesheetToken = "undefined-_agenticDetails";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
